module.exports = __webpack_public_path__ + "img/4_fineTeam_js.4588cfbf.png";